<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection>
          <div class="text-right">
            <argon-button :to="{ name: 'Create Unit Kerja' }" :isRouteLink="true"><font-awesome-icon icon="fa-solid fa-plus" /> Buat Baru</argon-button>
          </div>
        </MetaSection>
      </GridCol>
      <GridCol :size="12">
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :size="6">
                <div class="d-flex align-items-center justify-content-between gap-2">
                  <InputGroup class="m-0 filter">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="getData(params.keyword)" type="text" class="form-control"
                      placeholder="Cari nama unit kerja..." style="border-right: 1px solid #d2d6da!important;">
                  </InputGroup>

                  <!-- <FormGroup class="m-0 w-100">
                    <select-form @change="getData()" name="status" id="status" v-model="params.status" placeholder="Semua Status" :options="[{text: 'Aktif', value: 'active'}, {text: 'Non Aktif', value: 'inactive'}]" />
                  </FormGroup> -->
                </div>
              </GridCol>
            </GridRow>
          </template>
          <list-view>
            <template v-slot:thead>
              <tr>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Kode</th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Unit Kerja</th>
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Keterangan</th>
                <!-- <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Status</th> -->
                <th scope="col" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Aksi</th>
              </tr>
            </template>
            <template v-slot:tbody>
              <tr v-if="data.length < 1">
                <td colspan="5" class="text-center text-secondary">Tidak ada data</td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td>{{ item?.code || "-" }}</td>
                <td class="font-weight-bold">{{ item?.name || "-" }}</td>
                <td>{{ item?.description || '-' }}</td>
                <!-- <td>
                  <argon-badge v-if="item.status == 'active'" color="success">Aktif</argon-badge>
                  <argon-badge v-if="item.status == 'inactive'" color="danger">Non Aktif</argon-badge>
                </td> -->
                <td class="align-middle">
                  <ThreeDotsMenu>
                    <router-link :to="{ name: 'Update Unit Kerja', params: { id: item?.id ?? 0 } }"
                      class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Edit user">Edit</router-link>
                    <button @click.prevent="deleteData(item.id)"
                      class="text-secondary font-weight-bold text-xs btn btn-link" role="link" data-toggle="tooltip"
                      data-original-title="Delete user">Hapus</button>
                  </ThreeDotsMenu>
                </td>
              </tr>
            </template>
            <ArgonPagination :page="params.page" :total_page="metaData.total_page" :current_page="metaData.current_page" @changepage="changePage" @changelimit="changeLimit" />
          </list-view>
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
// import ArgonBadge from '@/components/ArgonBadge.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
import MetaSection from '@/components/MetaSection.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
import ListView from '@/components/ListView.vue';
import ArgonPagination from '@/components/ArgonPagination.vue';
// import SelectForm from '@/components/SelectForm.vue';
export default {
  name: "tables",
  components: {
    ArgonButton,
    CardComponent,
    InputGroup,
    // ArgonBadge,
    ThreeDotsMenu,
    MetaSection,
    GridRow,
    GridCol,
    ListView,
    ArgonPagination,
    // SelectForm,
  },
  data() {
    return {
      timer: undefined,
      data: [],
      params: {
        limit: "",
        // status: "",
        keyword: "",
        page: 1,
      },
      metaData: {}
    };
  },
  async mounted() {
    await this.getData();
  },
  watch: {
    'params.limit': {
      handler: async function () {
        this.params.page = 1
        await this.getData();
      },
      deep: false,
    },
    'params.page': {
      handler: async function (newVal, oldVal) {
        if (newVal < 1) {
          this.params.page = oldVal
        }
        else {
          // await this.getJabatan();
          await this.getData();
        }
      },
      deep: false,
    },
  },
  methods: {
    changeLimit(limit) {
      this.params.limit = limit
    },
    changePage(page) {
      this.params.page = page
    },
    async getData(keyword = "") {
      clearTimeout(this.timer)
      if (keyword.length <= 0) {
        await this.getDataAll();
      }
      else if (keyword.length >= 2) {
        this.timer = setTimeout(async () => {
          await this.getDataAll()
        }, 1500)
      }
    },
    async getDataAll() {
      this.$store.state.loading = true;
      let params = {}
      Object.keys(this.params).forEach(key => {
        if (!(this.params[key] === undefined || this.params[key] === null || this.params[key] === "")) {
          params[key] = JSON.parse(JSON.stringify(this.params[key]))
        }
      });
      await UnitKerjaApi.getbyparam(params).then((response) => {
        this.data = response.data;
        this.metaData = {
          status: response?.status ?? null,
          message: response?.message ?? null,
          total_item: response?.total_item ?? null,
          per_page: response?.per_page ?? null,
          total_page: response?.total_page ?? null,
          current_page: response?.current_page ?? null,
        }
      }).catch((error) => {
        if ((error?.response?.data?.detail ?? "") == 'Invalid page.') {
          this.params.page = this.params.page - 1;
        }
        this.metaData = {};
        this.data = [];
      });
      this.$store.state.loading = false;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await UnitKerjaApi.delete(id).then(() => {
            this.getData();
            this.$swal({
              icon: "success",
              title: "Berhasil"
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error?.response?.data?.message ?? "Data tidak dapat dihapus",
            });
          });
          this.$store.state.loading = false;
        }
      })
    }
  },
};
</script>
